export enum WriteAnimationEvents {
  FINISHED = 'animationFinished',
  STARTED = 'animationStarted',
}
